import { useState } from "react";
import { User } from "../model";
import { useAuth } from "@sky/xerxes-client-react";
import { UserService } from "../service";

type UserStore = {
    user: User | undefined;
    loading: boolean;
    fetch: (username: string) => void;
    clear: () => void;
}

const useUserStore = (): UserStore => {
    const { token } = useAuth();
    const [loading, setLoading] = useState<boolean>(false);
    const [user, setUser] = useState<User | undefined>(undefined);
    const userService = new UserService(token!);

    const fetch = async (username: string) => {
        try {
            setLoading(true);
            setUser(await userService.fetch(username));
        } catch (e) {
            setUser(undefined);
            console.error('Error fetching all users', e)
        } finally {
            setLoading(false);
        }
    }

    const clear = () => {
        setUser(undefined);
    }

    return {
        user, loading, fetch, clear
    }
}

export default useUserStore;